import type { SvgIconComponent } from '@mui/icons-material';
import { Box, Radio, Stack, ToggleButton, ToggleButtonProps, Typography } from '@mui/material';

type Props = Omit<ToggleButtonProps, 'title'> & {
    Icon: SvgIconComponent;
    title: string | React.ReactElement;
    subtitle?: string | React.ReactElement;
};
export const RadioToggleButton = ({ Icon, title, subtitle, ...props }: Props) => {
    return (
        <ToggleButton
            {...props}
            classes={{ root: 'p-[20px] justify-between text-black', selected: 'bg-transparent border-primary-600' }}
        >
            <Stack direction="row" spacing={2} alignItems="center">
                <Box
                    p="13px"
                    border={1}
                    borderColor="rgba(0, 0, 0, 0.16)"
                    borderRadius="5px"
                    bgcolor="neutral-100.main"
                >
                    <Icon sx={{ fontSize: 30 }} />
                </Box>
                <Box textAlign="left">
                    <Typography fontFamily="museo-sans" fontSize={16} fontWeight={600}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography fontSize={13.025} color="neutral-800">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Stack>
            <Radio checked={props.selected} onClick={(e) => props.onChange?.(e, !props.selected)} />
        </ToggleButton>
    );
};
